export default from './text-editor-video-embed-form';



// WEBPACK FOOTER //
// ./app/components/text-editor-video-embed-form/index.js